import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

interface Theme {
  id: number;
  name: string;
}

interface Package {
  id: number;
  name: string;
  themes?: Theme[];
}

interface Level {
  level: string;
  packages: Package[];
}

interface PackagesState {
  data: Level[];
  loading: boolean;
  error: string | null;
}

const initialState: PackagesState = {
  data: [],
  loading: false,
  error: null,
};

const packageSlice = createSlice({
  name: "packages",
  initialState,
  reducers: {
    setDropDown: (state, action: PayloadAction<Level[]>) => {
      localStorage.setItem('packagesdata',JSON.stringify(action.payload))
      state.data = action.payload;
    },
    getDropDown : (state) => {
      const data = localStorage.getItem('packagesdata')
      if(data){
        state.data = JSON.parse(data);
      }
    },
    removeDropDown: ()=>{
      localStorage.removeItem('packagesdata');
    }
  }
});

export const selectPackagesData = (state: RootState) => state.packages.data;

export const { setDropDown,getDropDown,removeDropDown } = packageSlice.actions;

export default packageSlice.reducer;
